export default "__VITE_ASSET__DZyD8jUK__"